import { Injectable } from '@angular/core';
import { BaseSmartFilterFormViewModel } from '../base-smart-filter-form-view-model';
import { map } from 'rxjs/operators';

@Injectable()
export class TerpeneAddEditSmartFilterFormViewModel extends BaseSmartFilterFormViewModel {
  public terpeneDropdowns$ = window.types.terpenes$;
  public terpenes$ = window.types.terpenes$.pipe(
    map(terpeneTypes => {
      return terpeneTypes?.map(t => {
        return {
          key: t?.getSelectionValue()?.toString()?.stripWhiteSpace(),
          text: t?.getSelectionValue()
        };
      });
    })
  );
}
